export default __webpack_public_path__ + "static/gift-card-11.url-c358baabfb1abe20aa133460d60305ee.svg";